import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import AspectRatioImage from 'components/atoms/aspect-ratio-image'
import Icon from 'components/atoms/icon'

const StyledContainerWrapper = styled.div`
  position: relative;
`

const Container = styled.label`
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  display: inline-block;
  position: relative;
  vertical-align: bottom;
  width: 100%;
  ${({ theme }) =>
    theme.cardBorderRadius &&
    `
      border-radius: ${theme.cardBorderRadius}px;
      overflow: hidden;
    `}
`

const Checkbox = styled.input`
  left: 12px;
  position: absolute;
  top: 12px;
`

const Overlay = styled.div`
  background: ${({ secondary, theme }) =>
    secondary ? theme.colors.brandCharlie : theme.colors.brandBravo};
  height: 100%;
  left: 0;
  opacity: ${({ visible }) => (visible ? 0.7 : 0)};
  position: absolute;
  top: 0;
  width: 100%;
`

const SphereBadge = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.fieldBackground};
  border-radius: ${({ theme }) => theme.sizings.lvl0};
  bottom: ${({ theme }) => theme.sizings.lvl1};
  display: flex;
  height: ${({ theme }) => theme.sizings.lvl3};
  justify-content: center;
  pointer-events: none;
  position: absolute;
  right: ${({ theme }) => theme.sizings.lvl1};
  width: ${({ theme }) => theme.sizings.lvl3};
  z-index: 1;

  svg {
    width: 100%;
    height: 100%;
  }
`

const StyledIconContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  width: ${({ theme }) => theme.sizings.lvl3};
  height: ${({ theme }) => theme.sizings.lvl3};
  background-color: ${({ theme }) => theme.colors.fieldBackground};
  border-radius: ${({ theme }) => theme.sizings.lvl0};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
  }
`

// @TODO Replace the checkbox input here with the generic Checkbox component
// when the label is removed from that component and the Checkbox with label
// is renamed to LabeledCheckbox
function MediaImage({
  alt,
  className,
  disabled,
  selected,
  onSelect,
  ratio,
  secondarySelected,
  src,
  onClick,
  exclusiveSelect,
  onImageClick,
  expandImage,
  isSphere,
}) {
  return (
    <StyledContainerWrapper>
      <Container className={className} onClick={onClick} $disabled={disabled}>
        <AspectRatioImage alt={alt} ratio={ratio} src={src} blurredBackground />
        <Overlay
          secondary={secondarySelected}
          visible={selected || secondarySelected}
        />
        {onSelect && (
          <Checkbox
            type={exclusiveSelect ? 'radio' : 'checkbox'}
            checked={selected}
            disabled={disabled}
            onChange={onSelect}
          />
        )}
      </Container>
      {isSphere && (
        <SphereBadge>
          <Icon type="360" size="lg" />
        </SphereBadge>
      )}
      {expandImage && onImageClick && (
        <StyledIconContainer
          onClick={(e) => {
            e.stopPropagation()
            onImageClick()
          }}
        >
          <Icon type="expand" size="lg" />
        </StyledIconContainer>
      )}
    </StyledContainerWrapper>
  )
}

MediaImage.propTypes = {
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
  onClick: PropTypes.func,
  ratio: PropTypes.number,
  selected: PropTypes.bool.isRequired,
  secondarySelected: PropTypes.bool,
  src: PropTypes.string.isRequired,
  exclusiveSelect: PropTypes.bool,
  onImageClick: PropTypes.func,
  expandImage: PropTypes.bool,
  /** Marks the thumbnail as a 360° sphere photo */
  isSphere: PropTypes.bool,
}

MediaImage.defaultProps = {
  className: null,
  disabled: false,
  onSelect: null,
  onClick: null,
  ratio: undefined,
  secondarySelected: false,
  exclusiveSelect: false,
  onImageClick: null,
  expandImage: false,
  isSphere: false,
}

export default MediaImage
